export class ListState {
  private selectedItems: string[] = [];
  private itemCount: number = 0;

  constructor(
    private readonly listTarget: HTMLElement,
    private readonly itemsSelectedTextTarget: HTMLElement,
    private readonly selectAllButtonTarget: HTMLElement,
    private readonly moveButtonTarget: HTMLElement
  ) {
    this.itemCount = this.listTarget.querySelectorAll('li').length;
  }

  public selectItem(value: string): void {
    this.selectedItems.push(value);
    this.updateState();
  }

  public unselectItem(value: string): void {
    this.selectedItems = this.selectedItems.filter(item => item !== value);
    this.updateState();
  }

  public selectAllItems(): void {
    const items = this.listTarget.querySelectorAll('li');
    items.forEach((item) => {
      const value = (item as HTMLElement).dataset.value;
      if (value && !this.isItemSelected(value)) {
        item.classList.add('selected');
        this.selectItem(value);
      }
    });
  }

  unselectAllItems(): void {
    const items = this.listTarget.querySelectorAll('li');
    items.forEach((item) => {
      const value = (item as HTMLElement).dataset.value;
      if (value) {
        item.classList.remove('selected');
        this.unselectItem(value);
      }
    });
  }

  public clearSelection(): void {
    this.selectedItems = [];
    this.updateState();
  }

  public isItemSelected(value: string): boolean {
    return this.selectedItems.includes(value);
  }

  public areAllItemsSelected(): boolean {
    return this.selectedItems.length === this.itemCount;
  }

  public getSelectedItems(): string[] {
    return [...this.selectedItems];
  }

  private updateState(): void {
    this.updateItemsSelectedText();
    this.updateMoveButtonState();
    this.updateSelectAllButtonText();
  }

  private updateItemsSelectedText(): void {
    this.itemsSelectedTextTarget.innerText = `${this.selectedItems.length}`;
  }

  private updateMoveButtonState(): void {
    if (this.selectedItems.length === 0) {
      this.moveButtonTarget.setAttribute('disabled', 'disabled');
    } else {
      this.moveButtonTarget.removeAttribute('disabled');
    }
  }

  private updateSelectAllButtonText(): void {
    if (this.areAllItemsSelected() && this.itemCount > 0) {
      this.selectAllButtonTarget.innerText = 'Deselect All';
    } else {
      this.selectAllButtonTarget.innerText = 'Select All';
    }
  }
}
